import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.platform_role === "superadmin" ? "/admin/platform" : "/admin"} replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { const u = await login(f.email, f.password); nav(u.platform_role === "superadmin" ? "/admin/platform" : "/admin"); } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="/seed/kit2.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/50" />
        <p className="absolute bottom-12 left-12 right-12 font-serif text-4xl text-white leading-tight">Every space deserves to be shown at its best.</p>
      </div>
      <div className="grid place-items-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="admin-login-form">
          <div>
            <img src="/logo.png" alt="Showhome Interactive" className="h-14 w-auto mb-6" data-testid="admin-login-logo" />
            <p className="text-xs uppercase tracking-[0.3em] text-ba">Client portal</p>
            <h1 className="font-serif text-4xl font-semibold mt-2">Sign in</h1>
            <p className="text-sm text-slate-500 mt-2">For builders, realtors, studios and operators using Showhome Interactive. Accounts are created by your administrator.</p>
          </div>
          <div><Label>Email</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="h-12" data-testid="admin-login-email" /></div>
          <div><Label>Password</Label><Input type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-12" data-testid="admin-login-password" /></div>
          {err && <p className="text-sm text-rose-600" data-testid="admin-login-error">{err}</p>}
          <button disabled={busy} className="w-full h-12 rounded-full bg-bp text-white font-semibold disabled:opacity-50" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </div>
  );
}
